const GOOGLE_ADS_ID = "AW-17339057437";
const SCRIPT_ID = "google-ads-gtag";

function ensureDataLayer() {
  if (!window.dataLayer) window.dataLayer = [];
  if (!window.gtag) {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }
}

function isScriptPresent() {
  return Boolean(document.getElementById(SCRIPT_ID));
}

export function loadGoogleAdsTag() {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  if (isScriptPresent()) return;

  ensureDataLayer();

  const script = document.createElement("script");
  script.id = SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GOOGLE_ADS_ID)}`;
  document.head.appendChild(script);

  window.gtag("js", new Date());
  // Best-effort consent mode (marketing only).
  window.gtag("consent", "update", { ad_storage: "granted" });
  window.gtag("config", GOOGLE_ADS_ID);
}

export function setGoogleAdsConsent(marketingAllowed) {
  if (typeof window === "undefined") return;
  if (!window.gtag) return;
  window.gtag("consent", "update", {
    ad_storage: marketingAllowed ? "granted" : "denied",
  });
}

export function getGoogleAdsId() {
  return GOOGLE_ADS_ID;
}

